const initShopToolbar = () => {
  const toolbar = document.querySelector('[data-shop-toolbar]')
  const page = document.querySelector('.woocommerce-page')
  const buttons = toolbar ? toolbar.querySelectorAll('[data-shop-view]') : []

  if (! toolbar || ! page || ! buttons.length) {
    return
  }

  const applyView = (view) => {
    const isList = view === 'list'

    page.classList.toggle('is-list-view', isList)
    page.classList.toggle('is-grid-view', ! isList)

    buttons.forEach((button) => {
      const active = button.dataset.shopView === view
      button.classList.toggle('is-active', active)
      button.setAttribute('aria-pressed', active ? 'true' : 'false')
    })
  }

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      applyView(button.dataset.shopView || 'grid')
    })
  })

  applyView('grid')
}

export default initShopToolbar



// WEBPACK FOOTER //
// ./resources/assets/js/components/shop-toolbar.js